
/**
 * Export `languages`.
 */

export en from 'client/translations/locales/en';
export pt from 'client/translations/locales/pt';



// WEBPACK FOOTER //
// ../src/client/translations/locales/index.js